import { Title } from "apps/batchOnboarding/Title";
import { GoogleMapsAPIProvider } from "apps/commons/components/GoogleMapsAPIProvider";
import { VStack } from "apps/commons/components/Stack";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { batchLocationBinder } from "libs/analytics/binders/batchOnboarding/batchLocation";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { PropertyList } from "./PropertyList";

export const LocationPage = () => {
    const {
        cmsData: { bulkLocation },
    } = useStaticDataAtomValue();

    useAnalytics(batchLocationBinder);

    return (
        <GoogleMapsAPIProvider>
            <VStack gap="24" pb="32">
                <Title title={bulkLocation.location} />
                <PropertyList />
            </VStack>
        </GoogleMapsAPIProvider>
    );
};
